<script lang="ts">
import type { ValueOf } from '../../types/helper';
import Icon from '../Icon/Icon.vue';

const colors = {
  white: 'white',
  grey: 'grey',
} as const;

const sizes = {
  s: 's',
  m: 'm',
} as const;

type Props = {
  ariaLabel?: string;
  color?: ValueOf<typeof colors>;
  endIcon?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: ValueOf<typeof sizes>;
  startIcon?: string;
  target?: string;
  text?: string;
  url?: string;
};
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<Props>(), {
  color: colors.white,
  size: sizes.m,
});

const emit = defineEmits(['click']);

const isLink = Boolean(props.url);
</script>

<template>
  <component
    :is="isLink || url ? 'a' : 'button'"
    :aria-label="ariaLabel"
    :class="[
      $style.container,
      $style[`color-${colors[color]}`],
      $style[`size-${sizes[size]}`],
      isActive && $style.active,
      isDisabled && $style.disabled,
    ]"
    :href="isLink ? url : null"
    :target="target === 'blank' ? '_blank' : '_self'"
    :type="isLink ? null : 'button'"
    @click="!isDisabled ? emit('click', $event) : null"
  >
    <Icon v-if="startIcon" :name="startIcon" size="small" />
    {{ text }}
    <Icon v-if="endIcon" :name="endIcon" size="small" />
  </component>
</template>

<style module lang="scss" src="./Tag.scss" />
